<template>
    <div>
        <form v-on:submit.prevent="onSubmit()">
            <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="form-group">
                        <label
                            :for="'keyword' + keyword_suggestion.id"
                            :id="'keyword-label' + keyword_suggestion.id"
                            class="mandatory-label"
                        >
                            {{ $root.text('Keyword', null, true) }} *
                        </label>
                        <input
                            v-model="keyword_suggestion.keyword"
                            type="text"
                            :id="'keyword' + keyword_suggestion.id"
                            class="form-control mandatory-field"
                            :readonly="updating"
                            v-on:keyup="$root.unHighlightErrors('keyword', keyword_suggestion.id)"
                            v-on:change="$root.unHighlightErrors('keyword', keyword_suggestion.id)"
                        >
                    </div>
                </div>
                <div class="col-lg-8 col-md-6">
                    <div class="form-group">
                        <label :for="'supporting_keywords' + keyword_suggestion.id">
                            {{ $root.text('Supporting keywords', null, true) }}</label>
                        <keywords-field
                            v-model="keyword_suggestion.supporting_keywords"
                            :value="keyword_suggestion.supporting_keywords"
                            :field_id="'supporting-keywords' + keyword_suggestion.id"
                            field_class="form-control pb-2"
                            :readonly="updating"
                            :keyword_placeholder="$root.text('Separate keywords with , then click +', null, true)"
                            :add_current_keyword="updating"
                            v-on:change="$root.unHighlightErrors('supporting-keywords', keyword_suggestion.id)"
                        ></keywords-field>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <span v-if="!updating">
                        <button
                            type="submit"
                            class="btn btn-primary mr-2"
                            :disabled="updating"
                        >
                            <i class="far fa-save mr-1"></i> {{ $root.text('Save', null, true) }}
                        </button>
                    </span>
                    <span v-else>
                        <button type="button" class="btn btn-primary mr-2">
                            <i class="fal fa-spinner-third fa-spin mr-1"></i>
                            <span style="opacity: 0.5">{{ $root.text('Save', null, true) }}</span>
                        </button>
                    </span>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        :disabled="updating"
                        @click.prevent="deleteKeywordSuggestion()"
                    >
                        <i class="far fa-trash-alt mr-1"></i> {{ $root.text('Delete', null, true) }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['data'],
        data () {
            return {
                errors: false,
                updating: false,
                keyword_suggestion: {}
            }
        },
        mounted () {
            if (this.data) {
                this.keyword_suggestion = this.data;
            }
        },
        watch: {
            data: function (val) {
                this.keyword_suggestion = val;
            }
        },
        methods: {
            onSubmit: function (delay = true) {
                this.errors = false;
                this.updating = true;
                var vm = this;
                if (delay) {
                    setTimeout(function () {
                        vm.onSubmit(false);
                    }, 200);

                    return null;
                }
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                /**
                 * Send update keyword suggestion request to API
                 */
                const url = this.$root.$data.app.api_url + '/' + this.$root.$data.app.client_id
                    + '/keyword-suggestion/' + this.keyword_suggestion.id;

                axios({
                    method: 'put',
                    url: url,
                    data: vm.keyword_suggestion,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.$data.token }
                })
                .then(response => {
                    // show confirmation message
                    vm.$parent.$parent.$parent.$parent.message = {
                        type: 'success',
                        title: vm.$root.text('Update keyword suggestion', null, true),
                        text: response.data.message
                    };
                    $('#message-modal').modal('show');

                    // close after 2 seconds automatically
                    setTimeout(function() {
                        $('#message-modal').modal('hide');
                    }, 2000);
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // missing/lost API token - logout user
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                        if (typeof error.response.data.error === 'string') {
                            vm.errors = error.response.data.error;
                        } else if (typeof error.response.data.error === 'object') {
                            vm.errors = '';
                            for (const [key, value] of Object.entries(error.response.data.error)) {
                                vm.errors += value.join('<br>') + '<br>';
                                $('#' + key + '-label' + vm.keyword_suggestion.id).addClass('text-danger');
                                $('#' + key + vm.keyword_suggestion.id).addClass('field-error');
                            }
                        }
                    }
                })
                .finally(() => {
                    vm.updating = false;
                });
            },
            deleteKeywordSuggestion: function (confirmed = false) {
                if (confirmed) {
                    this.errors = false;
                    this.loading = true;

                    /**
                     * Send delete keyword suggestion request to API
                     */
                    const url = this.$root.$data.app.api_url + '/' + this.$root.$data.app.client_id
                        + '/keyword-suggestion/' + this.keyword_suggestion.id;
                    var vm = this;

                    axios({
                        method: 'delete',
                        url: url,
                        headers: { 'Authorization': 'Bearer ' + vm.$root.$data.token }
                    })
                    .then(response => {
                        vm.$parent.$parent.getKeywordSuggestions();
                    })
                    .catch(function (error) {
                        if (error.response.status == 401) {
                            // missing/lost API token - logout user
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            vm.errors = error.response.data.error;
                        }
                    });

                    return null;
                }

                if (this.updating) {
                    return null;
                }

                this.$parent.$parent.$parent.$parent.confirm_delete = {
                    title: this.$root.text('Delete keyword suggestion', null, true),
                    text: this.$root.text(
                        'Are you sure you want to delete: {name}?',
                        { name: this.keyword_suggestion.keyword },
                        true
                    ),
                    component: this,
                    action: 'delete-keyword'
                };
                $('#confirm-delete-modal').modal('show');
            },
            confirmDelete: function (action) {
                this.deleteKeywordSuggestion(true);
            }
        }
    }
</script>
